import script from "./DocumentSurveyForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentSurveyForm.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentSurveyForm.vue?vue&type=style&index=0&id=3ebc03cd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ebc03cd"]])

export default __exports__